import Paper from '@material-ui/core/Paper'
import React from 'react'
import * as ReactDOM from 'react-dom'
import { Fade, withStyles } from '@material-ui/core'
import triangle from '../../media/symbols/triangle.png'
import celtic from '../../media/symbols/celtic.png'
import antifa from '../../media/symbols/antifa.png'
import anarchy from '../../media/symbols/anarchy.png'
import confederate from '../../media/symbols/confederate.png'
import islam from '../../media/symbols/islam.png'
import flag from '../../media/symbols/flag.png'
import metoo from '../../media/symbols/metoo.png'
import olympic from '../../media/symbols/olympic.png'
import peace from '../../media/symbols/peace.png'
import pepe from '../../media/symbols/pepe.png'
import refugees from '../../media/symbols/refugees.png'
import fist from '../../media/symbols/fist.png'
import letter from '../../media/symbols/letter.png'
import Typography from '@material-ui/core/Typography'
import { dynamicSort, shuffleArray } from './PyramidOfHateSegment'
import DialogContent from '@material-ui/core/DialogContent'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon'
import { scrollToTop } from './ArticlePointMapSegment'

export const MEMORY = 'MEMORY'

const styles = theme => ({
  pointsBackground: {
    margin: '0 auto',
    flex: 1
  },
  pyramidContainer: {
    display: 'flex',
    maxWidth: 1260
  },
  pyramidImage: {
    width: '50%',
    maxWidth: 630,
    minHeight: 1200

  },
  pyramidSvgContainer: {
    height: 170,
  },
  pyramidChoices: {
    width: '50%',
    maxWidth: 630
  },
  sortableList: {},

  sortableItem: {
    margin: '10px',
    textAlign: 'justify',
    paddingLeft: 5,
    borderLeft: 'black solid',
    minHeight: 160
  },
  SortableItemHeader: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    // margin: 5,
    padding: 3,
    textTransform: 'uppercase'
  },
  svg: {
    width: '100%',
    display: 'block',
    backgroundColor: '#EDEDED',
  },
  polygon: {
    fill: theme.palette.common.white,
    // fill: 'grey',
    stroke: theme.palette.divider,
    strokeWidth: 1,
  },
  svgText: {
    backgroundColor: theme.palette.primary.main,
    color: 'white'
  },
  pyramidHeader: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    display: 'block',
    position: 'relative',
    padding: 5,
    textAlign: 'center'
  },
  symbolsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    // width: '50%'
  },
  symbolCard: {
    borderStyle: 'solid',
    borderWidth: 6,
    borderColor: 'brown',
    width: 150,
    height: 120,
    margin: 5,
    alignContent: 'center',
    position: 'relative',
  },
  cardHeader: {
    fontSize: '0.9rem'

  },
  cardStory: {
    fontSize: '0.6rem'
  },
  symbolCardImage: {
    maxHeight: 70,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    position: 'absolute',
    // margin: '0 5%'
    padding: '5%'
  },
  symbolCardText: {
    textAlign: 'center',
    padding: 10,
    top: '60%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    position: 'absolute',
  },
  draggableText: {
    margin: 3
  },
  dropTarget: {
    // backgroundColor: 'green',
  },
})

let symbolStories = [
  {
    img: anarchy,
    title: 'ANARCHY SYMBOL',
    story: 'consists of the capital letter “A” derived from the first letter of “anarchy”. A is surrounded by the capital letter “O” that symbolizes the order. Together they communicate the society seeking order in anarchy.'
  },
  {
    img: antifa,
    title: 'ANTIFA FLAG',
    story: 'a red and black flag draped over each other representing anarchy (black) and communism or socialism (red).'
  },
  {
    img: celtic,
    hate: true,
    title: 'CELTIC CROSS',
    story: 'traditional Christian symbol with its origin in the pre-Christian pagan rituals. As it symbolized also Irish pride, it has become appropriated by white supremacists across the world. If not accompanied with other hate symbols and used in non-extremists contexts, it does not automatically denote white supremacist or racism.'
  },
  {
    img: confederate,
    title: 'CONFEDERATE FLAG',
    story: 'the 13-star saltire in red, white and blue has come into use during the American Civil War (1861-65) which was sparked by the issue of slavery. During the civil rights movement (1950s and 1960s), the flag became a symbol of segregation and was adopted by the Ku Klux Klan. While for some it represents ancestry and heritage for others it connotes slavery, hatred and white supremacy.'
  },
  {
    img: islam,
    hate: true,
    title: 'NO\u2011MOSQUE STICKERS',
    story: 'Stickers featuring a no smoking-style sign show a silhouette of a mosque and sometimes the words “no more mosques”. They mostly appear as intervention to public space like lamps or park benches and are connected to Islamophobic actions.'

  },
  {
    img: metoo,
    title: '#MeToo',
    story: 'is not a symbol per se and it has a large variety of local and international names and forms. As a hashtag on social media it spread virally in 2017 in an attempt to raise awareness of the prevalence of sexual harassment.'
  },
  {
    img: olympic,
    title: 'THE OLYMPIC RINGS',
    story: 'The symbol of the five interlocking rings, coloured blue, yellow, black, green, and red on a white field, was designed in 1912 by Pierre de Coubertin to represent the five continents (Europe, Asia, Africa, Oceania and America).'

  },
  {
    img: peace,
    title: 'PEACE SYMBOL',
    story: 'The symbol combines the semaphore signals for the letters “N” and “D” that stands for Nuclear Disarmament. Originally designed for the British nuclear disarmament movement, the symbol is today adopted by anti-war activists worldwide. In 1973 South African government tried to ban its use by opponents of apartheid.'
  },
  {
    img: pepe,
    title: 'PEPE THE FROG',
    story: 'First appeared in comic “Boy’s Club” by Matt Furie. It soon became a popular and widespread internet meme. In 2016 it was adopted as a symbol by white nationalists and the alt-right movement.'
  },
  {
    img: triangle,
    title: 'PINK TRIANGLE',
    story: 'First used in Nazi concentration camps to distinguish the prisoners of various LGBT identities, particularly homosexual men, pink triangle is now reclaimed as a positive symbol of pride and self-identity. LGB community has largely accepted it after it was first revived in 1970s in protests against homophobia.'
  },
  {
    img: flag,
    title:
      'RAINBOW FLAG',
    story: 'Symbolizes lesbian, gay, bisexual and transgender (LGBT) pride and LGBT social movements. The colors reflect the diversity of the LGBT community and is used worldwide, especially during the LGBT events, prides and marches.'
  },
  {
    img: fist,
    title: 'RAISED FIST',
    story: 'Or the clenched fist, is a salute to express solidarity, support, defiance or resistance. It is associated with different movements, left-wing politics as well as oppressed groups.'
  },
  {
    img: refugees,
    title: 'REFUGEES WELCOME',
    story: 'The silhouette of a running family is an art work of John Hood, who was tasked with designing the road sign for California in the late 1980s. It was used as a warning to motorists at a time when smugglers were forcing their charges to run across the freeway to evade immigration authorities. Stickers and memes accompanied by “Refugees Welcome” slogans were appropriated in the context of so called “Refugee Crisis” in Europe since 2015.'
  },
  {
    img: letter,
    title: 'A SCARLET LETTER',
    story: 'Originates from the 1850 romance novel by Nathaniel Hawthorne. Hester Prynne, the main protagonist, is sentenced to wear the scarlet letter “A” after she commits adultery. The symbol is sewn onto her clothes for everyone to see and is a representation of sin that aims to humiliate her. With time the meaning of the letter changed. Based on the Prynne’s strong and powerful character some readers refused to interpret the letter by its original meaning. Now it is related to “Able”, and even woman’s strength.'
  },
]

class SymbolsOfHateSegment extends React.Component {
  state = {
    correct: false,
    symbolItems: [],
    symbolsDone: [],
    detailsItem: null,
    symbolSelected: { story: null, symbol: null }
  }

  componentDidMount () {
    setTimeout(() => scrollToTop(this), 500)
    let rect = ReactDOM.findDOMNode(this)
      .getBoundingClientRect()
    if (!this.boundingRect) {
      this.boundingRect = rect
      this.forceUpdate()
    } else {
      this.boundingRect = rect
    }
    this.resetDraggable()
  }

  resetDraggable () {
    let symbolItems = []
    let itemContainers = []
    let key = 0
    let cardId = 0
    for (let i = 0; i < symbolStories.length; i++) {
      symbolItems.push({
        cardId, story: symbolStories[i].story,
        hate: symbolStories[i].hate,
        title: symbolStories[i].title, key: key++,
      })
      symbolItems.push({
        cardId, img: symbolStories[i].img,
        hate: symbolStories[i].hate,
        key: key++
      })
      cardId++
    }
    shuffleArray(symbolItems)
    this.setState({ symbolItems: symbolItems, itemContainers })
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    this.boundingRect = ReactDOM.findDOMNode(this)
      .getBoundingClientRect()
  }

  clickedCard (item) {
    let current = this.state.symbolSelected
    let { correct, symbolItems } = this.state
    let other
    if (correct && item.hate) {
      other = symbolItems.find(
        i => (i.cardId === item.cardId) && (i.key !== item.key)
      )
      other.hide = true
      item.hide = true
      this.setState({ symbolItems })
    } else {
      if (item.img) {
        current.symbol = item
      } else {
        current.story = item
      }
      this.setState({ symbolSelected: current })
      this.checkCorrect()
    }
  }

  checkCorrect () {
    let { symbolSelected, symbolsDone, symbolItems } = this.state
    if (symbolSelected.story && symbolSelected.symbol) {
      if (symbolSelected.symbol.cardId === symbolSelected.story.cardId) {
        symbolsDone.push(symbolSelected.story.cardId)
        this.setState({ symbolsDone, symbolSelected: { story: null, symbol: null } })
      } else {
        this.setState({ symbolSelected: { story: null, symbol: null } })
      }
    }

    if (symbolsDone.length === symbolStories.length) {
      symbolItems.sort(dynamicSort('key'))
      this.setState({ correct: true, symbolItems })
    }
  }

  itemToStyle (item) {
    let style = {}
    let { symbol, story } = this.state.symbolSelected

    if ((symbol && item.key === symbol.key)
      ||
      (story && item.key === story.key)) {
      style.borderColor = 'blue'
    }
    if (this.state.symbolsDone.indexOf(item.cardId) !== -1) {
      style.borderColor = 'green'
    }
    return style
  }

  showDetails (item) {
    this.setState({ detailsItem: item })
  }

  handleClose = () => {

    this.setState({ detailsItem: null })
  }

  render () {
    let {
      classes,
      // ...props
    } = this.props
    let { symbolItems, detailsItem } = this.state

    return <Paper>
      {/*Symbols of Hate {correct ? 'yes' : 'no'}*/}
      {/*{JSON.stringify(symbolSelected)}*/}
      {/*{JSON.stringify(symbolsDone)}*/}
      <div className={classes.symbolsContainer}>
        {symbolItems.map(item => (
          <Fade in={!item.hide} key={item.key} timeout={1000}>
            <div className={classes.symbolCard} key={item.key} onClick={() => {
              this.clickedCard(item)
            }} style={this.itemToStyle(item)}>
              {item.img && <img src={item.img} className={classes.symbolCardImage} alt={item.img}/>}
              {item.story && <div className={classes.symbolCardText}>
                <Typography variant='h4' className={classes.cardHeader}>{item.title}</Typography>
                <IconButton color="secondary" className={classes.button} aria-label="Details"
                            onClick={() => this.showDetails(item)}>
                  <Icon>info</Icon>
                </IconButton>

              </div>}
            </div>
          </Fade>
        ))

        }
      </div>

      <Dialog open={Boolean(detailsItem)}
              onClose={this.handleClose}
              scroll='paper'
      >
        {detailsItem ? <DialogTitle>
          {detailsItem && detailsItem.title}
        </DialogTitle> : ''}
        <DialogContent>
          <div className={classes.paper}>
            <Typography className={classes.cardStory}>
              {detailsItem && detailsItem.story}
            </Typography>
          </div>
        </DialogContent>
      </Dialog>
      <dialog>

      </dialog>
    </Paper>
  }
}

export default withStyles(styles)(SymbolsOfHateSegment)
